module.exports = __webpack_public_path__ + "img/no_data.6fffa864.png";